<section id="section_{{block.id}}" class="article-block-section block-{{block.position}} type-{{block.type}}">
  @if (block.type === 'text') {
    <div class="paragraaf image-{{block.imageAlign}}">
      @if (block.images.length) {
        <div class="img-wrapper" >
          <div class="img-wrap">
            <img [src]="block.images[0].image">
          </div>
          @if (block.images[0].name) {
            <div class="img-text">
              <span>{{block.images[0].name}}</span>
            </div>
          }
        </div>
      }
      @if (block.name || block.description) {
        <div class="text-wrapper" >
          @if (block.name) {
            <h2 class="paragraaf-title"><span>{{block.name}}</span></h2>
          }
          @if (block.description) {
            <div class="text" [innerHTML]="block.description"></div>
          }
        </div>
      }
    </div>
  }
  @if (block.type === 'gallery') {
    <div class="gallery">
      @if (block.name) {
        <h2 class="paragraaf-title"><span>{{block.name}}</span></h2>
      }
      <div class="gallery-items image-{{block.imageAlign}} image-count-{{block.imageColumnCount}}">
        @for (image of block.images; track image) {
          <div class="gallery-item">
            <div class="img-wrap">
              <img [src]="image.image">
            </div>
            @if (image.name) {
              <div class="img-text">
                <span>{{image.name}}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
  @if (block.type === 'video') {
    <div class="video">
      @if (block.name) {
        <h2 class="paragraaf-title"><span>{{block.name}}</span></h2>
      }
      @if (videoEmbedUrl; as embedUrl) {
        <div class="video-wrap">
          <iframe [src]="embedUrl" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>
        </div>
      }
    </div>
  }
  @if (block.type === 'checklist') {
    <div class="checklist">
      @if (block.name) {
        <h2 class="paragraaf-title"><span>{{block.name}}</span></h2>
      }
      <div class="checklist-items">
        @for (item of block.checklist; track item) {
          <div class="checklist-item">
            <div class="checkbox-wrap">
              <input type="checkbox" id="block_{{block.id}}_checklist_{{item.position}}"/>
              <label for="block_{{block.id}}_checklist_{{item.position}}"><span>{{item.name}}</span></label>
            </div>
          </div>
        }
      </div>
    </div>
  }
</section>